/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetDeviceAgentConfigurationSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetDeviceAgentConfigurationRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetDeviceAgentConfigurationSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetDeviceAgentConfigurationSecurity$outboundSchema: z.ZodMiniType<
  GetDeviceAgentConfigurationSecurity$Outbound,
  GetDeviceAgentConfigurationSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getDeviceAgentConfigurationSecurityToJSON(
  getDeviceAgentConfigurationSecurity: GetDeviceAgentConfigurationSecurity,
): string {
  return JSON.stringify(
    GetDeviceAgentConfigurationSecurity$outboundSchema.parse(
      getDeviceAgentConfigurationSecurity,
    ),
  );
}

/** @internal */
export type GetDeviceAgentConfigurationRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetDeviceAgentConfigurationRequest$outboundSchema: z.ZodMiniType<
  GetDeviceAgentConfigurationRequest$Outbound,
  GetDeviceAgentConfigurationRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getDeviceAgentConfigurationRequestToJSON(
  getDeviceAgentConfigurationRequest: GetDeviceAgentConfigurationRequest,
): string {
  return JSON.stringify(
    GetDeviceAgentConfigurationRequest$outboundSchema.parse(
      getDeviceAgentConfigurationRequest,
    ),
  );
}
